var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('span',[_vm._v(" Copyright "),_c('strong',[_vm._v("MG iMobil")]),_vm._v(" © "+_vm._s(_vm.year)+" - "),_c('strong',[_vm._v("Mega Assessoria")]),_vm._v(" © 2001 - "+_vm._s(_vm.year)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }